import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import FrontPage from '@/components/pages/FrontPage.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'FrontPage',
    component: FrontPage
	},
	{
    path: '/tripchimp',
    name: 'TripChimpPage',
    component: () => import(
			/* webpackChunkName: "user-stuff" */ 
			'@/components/pages/TripChimpPage.vue'
		)
  },
  {
    path: '/user-stuff',
    name: 'UserStuff',
    component: () => import(
			/* webpackChunkName: "user-stuff" */ 
			'@/components/pages/UserStuff.vue'
		)
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
